import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Parse an ISO date string (YYYY-MM-DD) as a LOCAL Date, not UTC.
 * Fixes the timezone bug where `new Date("2026-09-12")` gets treated as UTC midnight
 * and displays as Sept 11 in any timezone behind UTC.
 */
export function parseEventDate(isoDate) {
  if (!isoDate) return null;
  // If the string already has a time component, trust it. Otherwise anchor at local noon
  // so DST transitions can never nudge the calendar day.
  const s = typeof isoDate === "string" && isoDate.length === 10 ? `${isoDate}T12:00:00` : isoDate;
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** Format an ISO event date string using local timezone (no more Sept-12→Sept-11 drift). */
export function formatEventDate(isoDate, options = { weekday: "short", month: "long", day: "numeric" }) {
  const d = parseEventDate(isoDate);
  return d ? d.toLocaleDateString("en-US", options) : "";
}

